@if (step.createdByProvider) {
  <div class="metadata">
    <motn-user-avatar
      userIcon="fa-kit fa-chat"
      size="small"
      [showName]="true"
      [showMotiLabel]="true"
      [clickable]="true"
    ></motn-user-avatar>

    @if (step.createdAt) {
      <div class="timestamp">
        {{ formatTimestamp(step.createdAt) }}
      </div>
    }

    @if (showActions) {
      <div class="buttons">
          <moti-convo-bubble-options
            [step]="step"
            [loadingStep]="!!step.partialOrder"
            [showModel]="showModel"
            [enableEmailButton]="!step.errorAt"
            [enableRegenButton]="readyToAction && isLatestStep"
            [enableAddButton]="readyToAction && !step.errorAt"
            [enableDeleteButton]="readyToAction && isLatestStep"
            [deletingStep]="deletingStep"
            (clickedAdd$)="clickedAdd$.emit($event)"
            (clickedDelete$)="clickedDelete$.emit($event)"
          ></moti-convo-bubble-options>
      </div>
    }
  </div>
} @else {
  <div
    class="metadata"
    [class.rtl]="rtl"
  >
    <motn-user-avatar
      [user]="displayUser"
      size="small"
      [showName]="true"
      [clickable]="true"
      [rtl]="rtl"
      [avatarAfterName]="isCurrentUser"
    ></motn-user-avatar>

    @if (step.createdAt) {
      <div class="timestamp">
        {{ formatTimestamp(step.createdAt) }}
      </div>
    }

    <moti-convo-bubble-options
      [step]="step"
      [loadingStep]="!!step.partialOrder"
      [showModel]="false"
      [enableDeleteButton]="isLatestStep"
      [deletingStep]="deletingStep"
      (clickedDelete$)="clickedDelete$.emit($event)"
    ></moti-convo-bubble-options>
  </div>
}
